import React from 'react';
import { Link, LinkProps } from 'rebass';

const StyledLink = ({ sx, ...props }: LinkProps): JSX.Element => (
  <Link
    {...(props as any)}
    sx={{
      color: 'primary',
      fontSize: 1,
      fontWeight: 400,
      textDecoration: 'none',
      cursor: 'pointer',
      transition: 'color 0.15s ease, text-decoration-color 0.15s ease',
      '&:hover': {
        color: 'primaryHover',
        textDecoration: 'underline',
      },
      ...sx,
    }}
  />
);

export default StyledLink;
